/*
Looking to add a new experiment?
Read this - https://github.com/wix-private/wix-answers/blob/master/answers-client/core/experiments/README.md
*/
export var featureToggleMap = {
    SchedulesUsageInfo: {
        petriSpec: "specs.SchedulesUsageInfo",
        default: false,
        description: "Add the information about schedule usage in the schedule manager",
        mergeJira: "https://app.asana.com/0/1201962736292362/1202146139873572"
    },
    SchedulesUsageCount: {
        petriSpec: "specs.SchedulesUsageCount",
        default: false,
        description: "Add the `Applied in` column in schedules settings",
        mergeJira: "https://app.asana.com/0/1201358638192174/1202055282731710"
    },
    OmniChannelDashboard: {
        petriSpec: "specs.OmniChannel",
        default: false,
        description: "Omni channel dashboard page",
        mergeJira: ""
    },
    ChatTransfer: {
        petriSpec: "specs.ChatTransfer",
        default: false,
        description: "Enables Chat transfer capability",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201920516694870"
    },
    RealTimeViewsCounters: {
        petriSpec: "specs.RealTimeViewsCounters",
        default: false,
        description: "Realtime counters for saved views",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202173716626335/f"
    },
    EmailDashboard: {
        petriSpec: "specs.EmailDashboard",
        default: false,
        description: "Email Dashboard page in control room",
        mergeJira: "https://app.asana.com/0/1201257251712332/1201927316840307/f"
    },
    NewSignatureMenu: {
        petriSpec: "specs.NewSignatureMenu",
        default: false,
        description: "Signature menu on agent menu",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202012744388096/f"
    },
    SlaAssigneeCondition: {
        petriSpec: "specs.SlaAssigneeCondition",
        default: false,
        description: "Displays new SLA assignee condition design",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201889656797600"
    },
    TicketLocaleFilter: {
        petriSpec: "specs.TicketLocaleFilter",
        default: false,
        description: "Add locale filter to ticket filters",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202029962503576"
    },
    EnableUkrainian: {
        petriSpec: "specs.EnableUkrainian",
        default: false,
        description: "Slava Ukraini!",
        mergeJira: "N/A"
    },
    SchedulesSLA: {
        petriSpec: "specs.SchedulesSLA",
        default: false,
        description: "Use multiple schedules in SLA Settings",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201811413105632"
    },
    TimelineImprovements: {
        petriSpec: "specs.TimelineImprovements",
        default: false,
        mergeJira: ""
    },
    TimezoneSelector: {
        petriSpec: "specs.TimezoneSelector",
        default: false,
        description: "Displays timezone selector in schedule viewer comp",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201825361170505"
    },
    AutoRoutingFallbackHandler: {
        petriSpec: "specs.AotuRoutingFallbackHandler",
        default: false,
        description: "Add Fallback for AR when duplexer is down",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202040382134584/f"
    },
    CollapsibleInfoPanel: {
        petriSpec: "specs.CollapsibleInfoPanel",
        default: false,
        description: "Show/hide ticket page's info panel",
        mergeJira: "https://app.asana.com/0/1201324221515881/1201825333398917"
    },
    SavedFiltersNewApi: {
        petriSpec: 'specs.SavedFiltersNewApi',
        default: false,
        description: 'Use new API for get saved filters',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201825333398917'
    },
    UpdateSavedFiltersNewApi: {
        petriSpec: 'specs.UpdateSavedFiltersNewApi',
        default: false,
        description: 'Use new API for update save filters (relevant only for tenants with new brand or locale filter',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1202047519187574'
    },
    ControlRoomTableV2: {
        petriSpec: "specs.ControlRoomTableV2",
        default: false,
        description: "Ft for the table v2 in the control room",
        mergeJira: "https://app.asana.com/0/1200368299997249/1201293069096699"
    },
    OneInboxIncomingChatSound: {
        petriSpec: 'specs.OneInboxIncomingChatSound',
        default: false,
        description: 'plays sound on incoming chat message',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201775182790734/f'
    },
    NewTicketsCountApi: {
        petriSpec: 'specs.NewTicketsCountApi',
        default: false,
        description: 'use new API for tickets counter',
        mergeJira: 'https://app.asana.com/0/1201324218610427/1201739389847273/f',
    },
    EnableSimplifiedChinese: {
        petriSpec: 'specs.EnableSimplifiedChinese',
        default: false,
        description: 'Enables Articles CSV Import',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201686117324517'
    },
    TicketBrandsFilter: {
        petriSpec: 'specs.TicketBrandsFilter',
        default: false,
        description: 'Add brands filter to ticket filters',
        mergeJira: 'https://app.asana.com/0/1201324218610427/1201704171934523/f',
    },
    categoryCsvImport: {
        petriSpec: 'specs.categoryCsvImport',
        default: false,
        description: 'Enables Articles CSV Import',
        mergeJira: 'no need, its internal'
    },
    WidgetMultipleActiveChatSetting: {
        petriSpec: 'specs.WidgetMultipleActiveChatSetting',
        default: false,
        description: 'adds a an option to Chat setting to enable/disable opening a new chat while active on another',
        mergeJira: 'https://app.asana.com/0/1201324218610413/1201551356309006/f'
    },
    BobSnippet: {
        petriSpec: 'specs.EnableBobSnippet',
        default: false,
        description: 'Will add a new special Bob snippet in call center insights',
        mergeJira: 'TBD'
    },
    UseWixRecorder: {
        petriSpec: 'specs.UseWixRecorder',
        default: false,
        description: 'Enables user session recording',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12045'
    },
    MultiSelectV3: {
        petriSpec: 'specs.MultieSelectV3',
        default: false,
        description: 'Enables Multi Select V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17740'
    },
    WidgetDraggable: {
        petriSpec: 'specs.EnableWidgetDraggable',
        default: false,
        description: 'Enables Widget V3 draggable feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9473'
    },
    WidgetFeedbackTypes: {
        petriSpec: 'specs.WidgetFeedbackTypes',
        default: false,
        description: 'Enables voting and reporting of Widget articles',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201785673092086/f'
    },
    WidgetIconMsg: {
        petriSpec: 'specs.EnableWidgetIconMsg',
        default: false,
        description: 'Enables Widget V3 icon msg settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9615'
    },
    WidgetChatbot: {
        petriSpec: 'specs.WidgetChatbot',
        default: false,
        description: 'Enables Chatbot in Widget V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10793'
    },
    SlaPolicies: {
        petriSpec: 'specs.SlaPolicies',
        default: false,
        description: 'Enables SLA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9712'
    },
    CustomFields: {
        petriSpec: 'specs.CustomFields',
        default: false,
        description: 'New Custom Fields Customers / Tickets',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9713'
    },
    ChatDevice: {
        petriSpec: 'specs.ChatDevice',
        default: false,
        description: 'Adds Chat Device to App for AutoAssign feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9978'
    },
    ChatAutoAssign: {
        petriSpec: 'specs.ChatAutoAssign',
        default: false,
        description: 'Chat Auto Assign settings page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10093',
    },
    EnableMacros: {
        petriSpec: 'specs.EnableMacros',
        default: false,
        description: 'enables macros on tickets settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10432'
    },
    NewUpgradeFlow: {
        petriSpec: 'specs.NewUpgradeFlow',
        default: false,
        description: 'enables the new upgrade flow and the new package picker for Answers Premium',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10477'
    },
    HelpcenterSettingsV2: {
        petriSpec: 'specs.HelpcenterSettingsV2',
        default: false,
        description: 'enables helpcenter settings V2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10669'
    },
    CallDelay: {
        petriSpec: 'specs.CallDelay',
        default: false,
        description: 'Enables call delay option for agents',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10946'
    },
    CustomFieldsLimit: {
        petriSpec: 'specs.CustomFieldsLimit',
        default: false,
        description: 'Increases custom fields limits',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11019'
    },
    CompactCallDevice: {
        petriSpec: 'specs.CompactCallDevice',
        default: false,
        description: 'Call Device redesign',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11304'
    },
    ChatHotkeys: {
        petriSpec: 'specs.ChatHotkeys',
        default: false,
        description: 'Enables hotkeys for Chat Jira: WA-11436',
        mergeJira: 'TBD'
    },
    WhatsappAttachments: {
        petriSpec: 'specs.WhatsappAttachments',
        default: false,
        description: 'Enables Whatsapp attachments from the App to Whatsapp',
        mergeJira: 'TBD - internal'
    },
    RemoveCreditBlock: {
        petriSpec: 'specs.RemoveCreditBlock',
        default: false,
        description: 'Removes Ticket Page block when credits are insufficient.',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12357'
    },
    UploadZipFiles: {
        petriSpec: 'specs.UploadZipFiles',
        default: false,
        description: 'Enables uploading zip files (made for MH)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12135'
    },
    DashboardOutboundCallsAndTotalTime: {
        petriSpec: 'specs.DashboardOutboundCallsAndTotalTime',
        default: false,
        description: 'Patch for outbound sales MH account (and others) to include outbound calls to dashboard without adding filters to the UI. This also adds a "total call time" in the agents table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12295'
    },
    TicketsListNewPresenceComponent: {
        petriSpec: 'specs.TicketsListNewPresenceComponent',
        default: false,
        description: 'Enables new ticket list presence design',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12391',
    },
    SlaSettingsV2: {
        petriSpec: 'specs.SlaSettingsV2',
        default: false,
        description: 'Enables SLA settings v2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12461'
    },
    EditCategoryIconSrc: {
        petriSpec: 'specs.EditCategoryIconSrc',
        default: false,
        description: 'Allows editing of category icon by source only, while keeping the icon key. Needed for new HC',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12515'
    },
    AnswersEnableChatWebhooksDigibankPOC: {
        petriSpec: 'specs.AnswersEnableChatWebhooksDigibankPOC',
        default: false,
        description: 'Enables chat webhooks for digibank POC - client and server',
        mergeJira: 'https://jira.wixpress.com/browse/WONT-BE-MERGED'
    },
    ControlRoom: {
        petriSpec: 'specs.ControlRoom',
        default: false,
        description: 'Control room page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12754'
    },
    OneInbox: {
        petriSpec: 'specs.OneInbox',
        default: false,
        description: 'One Inbox page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12763'
    },
    AdvancedReportsWasabi: {
        petriSpec: 'specs.AdvancedReportsWasabi',
        default: false,
        description: 'wasabi insights reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13148'
    },
    CallTypeIndicator: {
        petriSpec: 'specs.CallTypeIndicator',
        default: false,
        description: 'add a call type column to call center',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13463'
    },
    WorkflowsBetaScenarios: {
        petriSpec: 'specs.WorkflowsBetaScenarios',
        default: false,
        description: 'Opening this experiment enables spotter scenarios that are still in dev',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14377'
    },
    OutboundChat: {
        petriSpec: 'specs.OutboundChat',
        default: false,
        description: 'Enables the option to open an outbound chat',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14070'
    },
    NewTicketModal: {
        petriSpec: 'specs.NewTicketModal',
        default: false,
        description: 'renders the new refactored ticket modal',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14131'
    },
    Partners: {
        petriSpec: 'specs.EnablePartners',
        default: false,
        description: 'enables partner users in app',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14133'
    },
    ForceHotjarTracking: {
        petriSpec: 'specs.ForceHotjarTracking',
        default: false,
        description: 'forces hotjar tracking',
        mergeJira: 'should never be merged'
    },
    JiraIntegrationV2: {
        petriSpec: 'specs.JiraIntegrationV2',
        default: false,
        description: 'enables new features for Jira Integration',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14172'
    },
    ReplyBoxShowAllEmojis: {
        petriSpec: 'specs.ReplyBoxShowAllEmojis',
        default: false,
        description: 'does not limit emojis shown in reply box (WA-13278)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14176'
    },
    CustomCompanyFieldsFilters: {
        petriSpec: 'specs.CustomCompanyFieldsFilters',
        default: false,
        description: 'Enables custom company fields in One Inbox Views',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14413'
    },
    NewLinesSettingsTable: {
        petriSpec: 'specs.NewLinesSettingsTable',
        default: false,
        description: 'New line settings table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14635'
    },
    AgentLocaleInterfacePicker: {
        petriSpec: 'specs.AgentLocaleInterfacePicker',
        default: false,
        description: 'Enables agent locale interface picker from user editor',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14721'
    },
    HC2SectionsCodeOverrides: {
        petriSpec: 'specs.HC2SectionsCodeOverrides',
        default: false,
        description: 'Enables code overrides for all sections in HCv2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14769'
    },
    APIReactQuery: {
        petriSpec: 'specs.AnswersAPIReactQuery',
        default: false,
        description: 'Wraps the API layer with React Query',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14859'
    },
    OneInboxCache: {
        petriSpec: 'specs.AnswersOneInboxCache',
        default: false,
        description: 'Enables the cache layer for OneInbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15339'
    },
    ChatbotBuilderPOC: {
        petriSpec: 'specs.ChatbotBuilderPOC',
        default: false,
        description: 'POC of chatbot builder',
        mergeJira: 'Wont merge'
    },
    WasabiMocks: {
        petriSpec: 'specs.WasabiMocks',
        default: false,
        description: 'wasabi mock reports for marketing use',
        mergeJira: 'wont merge'
    },
    WorkflowsBetaConditions: {
        petriSpec: 'specs.WorkflowsBetaConditions',
        default: false,
        description: 'Hides spotter conditions that did not go through QA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15171'
    },
    LogDuplexerMessages: {
        petriSpec: 'specs.LogDuplexerMessages',
        default: false,
        description: 'logs all duplexer messages for debug purposes',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15401'
    },
    CallcenterLogs: {
        petriSpec: 'specs.CallcenterLogs',
        default: false,
        description: 'enables debug logs for callcenter',
        mergeJira: 'TBD'
    },
    HCNextPrevArticle: {
        petriSpec: 'specs.HCNextPrevArticle',
        default: false,
        description: 'enables settings for next prev buttons',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15470'
    },
    DisableMobileLock: {
        petriSpec: 'specs.DisableMobileLock',
        default: false,
        description: 'disables mobile lock',
        mergeJira: 'TBD'
    },
    OneInboxChatStats: {
        petriSpec: 'specs.OneInboxChatStats',
        default: false,
        description: 'Enables Chat Stats in OI, requested by WIX',
        mergeJira: 'TBD'
    },
    ShowOneInboxVideo: {
        petriSpec: 'specs.ShowOneInboxVideo',
        default: false,
        description: 'Shows one inbox video on first time usage',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15725'
    },
    SlaInsightsV2: {
        petriSpec: 'specs.SlaInsightsV2',
        default: false,
        description: 'enables the sla insights v2 inside new ticket insights',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15860'
    },
    OneInboxChatSoundNotification: {
        petriSpec: 'specs.OneInboxChatSoundNotification',
        default: false,
        description: 'Play sound notification when there is a new chat in One Inbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15985'
    },
    CustomerPortalSettings: {
        petriSpec: 'specs.CustomerPortalSettings',
        default: false,
        description: 'Customer portal settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15991'
    },
    OneInboxChatStatusFilter: {
        petriSpec: 'specs.OneInboxChatStatusFilter',
        default: false,
        description: 'add filter by chat status to OI',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15979'
    },
    EmailOpenIndication: {
        petriSpec: 'specs.EmailOpenIndication',
        default: false,
        description: 'adds sent and read indication for agent replies',
        mergeJira: 'TBD'
    },
    ContextualArticlesInAnswersWidget: {
        petriSpec: 'specs.ContextualArticlesInAnswersWidget',
        default: false,
        description: 'Add contextual articles to wixanswers widget',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15771'
    },
    EndChat: {
        petriSpec: 'specs.EndChat',
        default: false,
        description: 'new end chat flow',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16377'
    },
    CallCenterDashboard: {
        petriSpec: 'specs.CallCenterDashboard',
        default: false,
        description: 'Enables new Call Center Dashboard',
        mergeJira: ''
    },
    UseGoogleFontCdn: {
        petriSpec: 'specs.UseGoogleFontCdn',
        default: false,
        description: 'uses google font cdn for fira sans with specific font weights',
        mergeJira: ''
    },
    PaymentDetails: {
        petriSpec: 'specs.PaymentDetails',
        default: false,
        description: 'Enables Payment and Billing details',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16674'
    },
    WasabiCustomReports: {
        petriSpec: 'specs.WasabiCustomReports',
        default: false,
        description: 'enables WASABI custom reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16862'
    },
    LoggingACall: {
        petriSpec: 'specs.LoggingACall',
        default: false,
        description: 'Logging a Call feature for answers app (internal notes + custom fields)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17013'
    },
    SpotterEndChatAction: {
        petriSpec: 'specs.SpotterEndChatAction',
        default: false,
        description: 'new end chat action',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17142'
    },
    RealtimeTicketsPresence: {
        petriSpec: 'specs.RealtimeTicketsPresence',
        default: false,
        description: 'tickets RT presence',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17013'
    },
    HelpcenterSdkAddOnContactForm: {
        petriSpec: 'specs.HCOnContactFormRender',
        default: false,
        description: 'Adds onContactFormRendered method to Helpcenter sdk',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17127'
    },
    TwitterTicket: {
        petriSpec: 'specs.TwitterTicket',
        default: false,
        description: 'Twitter Ticket',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17295'
    },
    FourMillionBar: {
        petriSpec: 'specs.FourMillionBar',
        default: false,
        description: '$4,000,000',
        mergeJira: 'never'
    },
    MultilevelFields: {
        petriSpec: 'specs.MultilevelFields',
        default: false,
        description: 'Multilevel Fields in the viewer side',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17286'
    },
    SamlSsoLogin: {
        petriSpec: 'specs.SamlSsoLogin',
        default: false,
        description: 'Enables SAML SSO Login',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17393'
    },
    CsatConditions: {
        petriSpec: 'specs.CsatConditions',
        default: false,
        description: 'Adds CSAT conditions table to settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17715'
    },
    ChatDashboard: {
        petriSpec: 'specs.ChatDashboard',
        default: false,
        description: 'Chat dashboard page in control room',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17824'
    },
    ChatDashboardUS8: {
        petriSpec: 'specs.ChatDashboardUS8',
        default: false,
        description: 'user story 8 of Chat dashboard page in control room',
        mergeJira: 'https://app.asana.com/0/1192927316903892/1201503208442343'
    },
    HelpcenterContactFormEmailConfirmation: {
        petriSpec: 'specs.HelpcenterContactFormEmailConfirmation',
        default: false,
        description: 'Adds email confirmation to helpcenter contact form',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17888'
    },
    AnswersPackagePickerPaymentInfoForm: {
        petriSpec: 'specs.AnswersPackagePickerPaymentInfoForm',
        default: false,
        description: 'Answers package picker, display the payment info form separately',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17993'
    },
    MultipleLocalesViews: {
        petriSpec: 'specs.MultipleLocalesViews',
        default: false,
        description: 'support multiple locales in views',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17871'
    },
    SchedulesP3: {
        petriSpec: 'specs.SchedulesP3',
        default: false,
        description: 'Schedules phase 3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17980'
    },
    CsatSubmitInitialRating: {
        petriSpec: 'specs.CsatSubmitInitialRating',
        default: false,
        description: 'https://jira.wixpress.com/browse/WA-17386',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17386'
    },
    SpotterScenario52MonitorAgentSessions: {
        petriSpec: 'specs.SpotterScenario52MonitorAgentSessions',
        default: false,
        description: 'Enables scenario 52 of spotter - Monitor agent sessions in ticket',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1201927524374582'
    },
    PrivateViewsPermission: {
        petriSpec: 'specs.PrivateViewsPermission',
        default: false,
        description: 'Private views permission',
        mergeJira: 'https://jira.wixpress.com/browse/WA-18241'
    },
    ChatSecuredFiles: {
        petriSpec: 'specs.ChatSecuredFiles',
        default: false,
        description: 'sends all chat files as secured',
        mergeJira: 'https://jira.wixpress.com/browse/WA-18255'
    },
    CallPriorityScoring: {
        petriSpec: 'specs.CallPriorityScoring',
        default: false,
        description: 'Enables features based on calls priority scoring',
        mergeJira: 'https://jira.wixpress.com/browse/WA-18386'
    },
    IOS_15_IPHONE_PATCH: {
        petriSpec: 'specs.IOS_15_IPHONE_PATCH',
        default: false,
        description: 'IOS_15_IPHONE_PATCH',
        mergeJira: 'https://jira.wixpress.com/browse/WA'
    },
    SchedulesQueues: {
        petriSpec: 'specs.SchedulesQueues',
        default: false,
        description: 'adds multiple schedule functionality to queues',
        mergeJira: 'https://app.asana.com/0/1201284768785864/1201301842728280/f'
    },
    MultiBrandTicketing: {
        petriSpec: 'specs.MultiBrandTicketing',
        default: false,
        description: 'enables multi brand ticketing',
        mergeJira: 'https://app.asana.com/0/1201324221515916/1201370462400075/f'
    },
    MultiBrandTicketPermission: {
        petriSpec: 'specs.MultiBrandTicketPermission',
        default: false,
        description: 'add permission of change ticket name to roles and in UI',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1202104687796470/f'
    },
    SpotterCallTransferredScenario: {
        petriSpec: 'specs.SpotterCallTransferredScenario',
        default: false,
        description: 'Enables Spotter scenario 100',
        mergeJira: 'https://app.asana.com/0/1201044419602909/1201370361650162/f'
    },
    SpotterNewCallScenario: {
        petriSpec: 'specs.SpotterNewCallScenario',
        default: false,
        description: 'Enables Spotter scenario 101',
        mergeJira: 'https://app.asana.com/0/1201044419602909/1201370361650158/f'
    },
    SpotterChangePriorityScoreAction: {
        petriSpec: 'specs.SpotterChangePriorityScoreAction',
        default: false,
        description: 'Enables change priority score action in spotter',
        mergeJira: 'https://app.asana.com/0/1201044419602909/1201388120347802/f'
    },
    AutoRutingHideDeviceAfterDelay: {
        petriSpec: 'specs.AutoRutingHideDeviceAfterDelay',
        default: false,
        description: 'Do not show device afer 10sec delay',
        mergeJira: 'https://app.asana.com/0/1201324221515924/1201538735360714/f'
    },
    EmailTemplatesAdditionalToggles: {
        petriSpec: 'specs.EmailTemplatesAdditionalToggles',
        default: false,
        description: 'Adds toggles to Ticket Replied and Resolved',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201244034457393/f'
    },
    OINewestFirstSort: {
        petriSpec: 'specs.OINewestFirstSort',
        default: false,
        description: 'add a Newest first sort the the ticket list in OI (all layouts)',
        mergeJira: 'https://app.asana.com/0/1201324221515924/1201472554335962/f'
    },
    ReCaptchaV3: {
        petriSpec: 'specs.ReCaptchaV3',
        default: false,
        description: 'Upgrade to use ReCaptchaV3',
        mergeJira: 'https://app.asana.com/0/1201324221515909/1201473019990380/f'
    },
    ShopifyMultipleStores: {
        petriSpec: 'specs.ShopifyMultipleStores',
        default: false,
        description: 'Adds multiple stores to shopify integration',
        mergeJira: 'https://app.asana.com/0/1201324218610413/1201482149596433'
    },
    SpotterScenario19GlobalStatuses: {
        petriSpec: 'specs.SpotterScenario19GlobalStatuses',
        default: false,
        description: 'Enables support of global agent statuses in Spotter scenario 19',
        mergeJira: 'https://app.asana.com/0/1201044419603056/1201491369761855'
    },
    PauseCallRecording: {
        petriSpec: 'specs.PauseCallRecording',
        default: false,
        description: 'Enables recording controls, pause/resume',
        mergeJira: 'https://app.asana.com/0/1201047807369700/1201508256503815'
    },
    BlockPauseCallRecording: {
        petriSpec: 'specs.BlockPauseCallRecording',
        default: false,
        description: 'Hide/show recording controls, in UI',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1202085624642190/f'
    },
    LazyContactsSearch: {
        petriSpec: 'specs.LazyContactsSearch',
        default: false,
        description: 'makes contacts and companies search lazy for one inbox',
        mergeJira: 'https://app.asana.com/0/1201047807369700/1201508256503815'
    },
    LinkArticleBrandPicker: {
        petriSpec: 'specs.LinkArticleBrandPicker',
        default: false,
        description: 'add brand picker to link article filters modal in ticket page',
        mergeJira: 'https://app.asana.com/0/1201047807369700/1201508256503815'
    },
    WidgetReCaptchaV3: {
        petriSpec: 'specs.WidgetReCaptchaV3',
        default: false,
        description: 'WidgetReCaptchaV3',
        mergeJira: 'https://app.asana.com/0/1201047807369700/1201508256503815'
    },
    SchedulesLines: {
        petriSpec: 'specs.SchedulesLines',
        default: false,
        description: 'adds multiple schedule functionality to lines',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201634249053405/f'
    },
    NewTicketModalMandatoryCustomFields: {
        petriSpec: 'specs.NewTicketModalMandatoryCustomFields',
        default: false,
        description: 'Enables showing mandatory custom fields in new ticket modal using backoffice SDK',
        mergeJira: 'https://app.asana.com/0/1201446965042756/1201669409499127'
    },
    InfiniteScrollRemoveContainer: {
        petriSpec: 'specs.InfiniteScrollRemoveContainer',
        default: false,
        description: 'enable to remove infinite scroll container safely',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1201763724509451'
    },
    SpotterActiveScenariosListLayout: {
        petriSpec: 'specs.SpotterActiveScenariosListLayout',
        default: false,
        description: 'Enables list layout of active scenarios in Spotter',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202029730905900/f'
    },
    SpotterScenario56: {
        petriSpec: 'specs.SpotterScenario56',
        default: false,
        description: 'Enables scenario 56 in Spotter - monitor chat transfers per agent',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202316369339997/f'
    },
    SpotterScenario57: {
        petriSpec: 'specs.SpotterScenario57',
        default: false,
        description: 'Enables scenario 57 in Spotter - reduce transferred call wait time',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202194856021298/f'
    },
    SpotterScenario58: {
        petriSpec: 'specs.SpotterScenario58',
        default: false,
        description: 'Enables scenario 58 in Spotter - reduce transferred chat wait time',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202327972919671/f'
    },
    MultilevelFieldsWidget: {
        petriSpec: 'specs.MultilevelFieldsWidget',
        default: false,
        description: 'Enables multilevel fields in widget',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201720752532849/f'
    },
    MultilevelFieldsHelpcenter: {
        petriSpec: 'specs.MultilevelFieldsHelpcenter',
        default: false,
        description: 'Enables multilevel fields in helpcenter',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201720752532855/f'
    },
    MultilevelMultiLingual: {
        petriSpec: 'specs.MultilevelMultiLingual',
        default: false,
        description: 'Enables translating multilevel custom fields',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201707008271604/f'
    },
    OneInboxPreventSettingsSaveOnLoad: {
        petriSpec: 'specs.OneInboxPreventSettingsSaveOnLoad',
        default: false,
        description: 'OneInbox Prevent Settings Save OnLoad',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201720752532855/f'
    },
    CompactButtonGroupMenu: {
        petriSpec: 'specs.CompactButtonGroupMenu',
        default: false,
        description: 'Hides menu if there are no addiotinal actions',
        mergeJira: 'https://app.asana.com/0/1201324218610427/1201775033091315'
    },
    SetAvailableNewApi: {
        petriSpec: 'specs.SetAvailableNewApi',
        default: false,
        description: 'new API to set Available status after decline a call',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201749639329248'
    },
    WidgetNewTranslations: {
        petriSpec: 'specs.WidgetNewTranslations',
        default: false,
        description: 'in-artifact translation in the widget',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1201842273084941'
    },
    SubSubCategoriesSettings: {
        petriSpec: 'specs.SubSubCategoriesSettings',
        default: false,
        description: 'Enabled subsub-categories helpcenter settings changes',
        mergeJira: 'https://app.asana.com/0/1201324221515895/1201899298987377/f'
    },
    HCTicketAttachmentLinkAsRelative: {
        petriSpec: 'specs.HCTicketAttachmentLinkAsRelative',
        default: false,
        description: 'Converts Help ticket attachment links to relative links.',
        mergeJira: 'https://app.asana.com/0/1201324221515895/1201928011944548'
    },
    OneInboxSettingsOnLoad: {
        petriSpec: 'specs.OneInboxSettingsOnLoad',
        default: false,
        description: 'OneInbox Prevent Settings Save OnLoad',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201720752532855/f'
    },
    PublicAnchorLinkAsAbsolute: {
        petriSpec: 'specs.PublicAnchorLinkAsAbsolute',
        default: false,
        description: 'Enables absolute(whole url) anchor-links instead of fragment part only for the old helpcenter.',
        mergeJira: 'https://app.asana.com/0/1201324221515895/1201947969657865'
    },
    LogMicrophonePermissions: {
        petriSpec: 'specs.LogMicrophonePermissions',
        default: false,
        description: 'Checks Agents microphone permission before accepting a call and logs it.',
        mergeJira: 'N/A'
    },
    NotificationsSettings: {
        petriSpec: 'specs.NotificationsSettings',
        default: false,
        description: 'Manage notification settings in a dedicated page',
        mergeJira: 'N/A'
    },
    OneInboxAssigneeFilterRefactor: {
        petriSpec: 'specs.OneInboxAssigneeFilterRefactor',
        default: false,
        description: 'refactors the assignee filter to use logical OR operator instead of AND',
        mergeJira: 'https://app.asana.com/0/0/1202104636446070/f'
    },
    SearchResultsPagination: {
        petriSpec: 'specs.SearchResultsPagination',
        default: false,
        description: 'Enables the pagination for the search results page',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1202282830817358/f'
    },
    NewTicketModalMultiLevelCustomFields: {
        petriSpec: 'specs.NewTicketModalMultiLevelCustomFields',
        default: false,
        description: 'multi level custom fields in the new ticket modal',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1202254670205839/f'
    },
    BrandConditionAA: {
        petriSpec: 'specs.BrandConditionAA',
        default: false,
        description: 'brand as a condition in automatic actions',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1202318276408446/f'
    }
};
//# sourceMappingURL=features.js.map